import React, { useEffect } from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import injectSheet, { ThemeProvider } from 'react-jss';
import { AnalyticsManager, onetrust } from '@src/analyticsManager';
import themes from '../../themes';
import Analytics from '../analytics';
import styleSheet from './styles';
import { Routes } from '../routes';
import ApolloRootProvider from '../hoc/Apollo';

Bugsnag.start({
  apiKey: `${process.env.REACT_APP_BUGSNAG_TAG}`,
  plugins: [new BugsnagPluginReact()],
  releaseStage: process.env.NODE_ENV,
  // for GDPR
  collectUserIp: false,
  redactedKeys: [/^userkey$/i, /^sessionid$/i, /^embed$/i, /^password$/i],
  autoTrackSessions: false, // Auto Track Session is off. It will be started manually after user gives Cookie Consent.
  onError: event => {
    if (!onetrust.hasAnalyticsCookiesConsent()) {
      // Remove generated anonymous ID (event.device.id) from report if user do not give consent for Analytics Cookies
      // eslint-disable-next-line no-param-reassign
      event.device.id = null;
      event.setUser('[REDACTED]');
      // eslint-disable-next-line no-param-reassign
      event.breadcrumbs = null;
    }
  },
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

const App: React.FC<any> = props => {
  useEffect(() => {
    Analytics.EventAnalytics.bindWindowEvents();
  }, []);

  return (
    <ErrorBoundary>
      <ThemeProvider theme={themes}>
        <ApolloRootProvider>
          <AnalyticsManager />
          <Routes tour={props} />
        </ApolloRootProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default injectSheet(styleSheet)(App);
